export enum ConfirmationType {
    DELETE,
    RESET,
    RESTART,
    CONFIRMATION
}